export default {
  LOGIN: 'login',
  LOGIN_CRM: 'login-crm',
  LOGIN_LANDING: 'login-landing',
};